<template>
  <v-container fluid grid-list-lg>
    <v-form ref="form1" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 sm4>
          <v-text-field
            label="Name"
            v-model="fields.name"
            box
            required
            messages="changed"
            clearable
            background-color="secondary lighten-2"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            label="Agency ID"
            v-model="fields.tracking_id"
            box
            hide-details
            required
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4>
          <v-checkbox
            label="Cash Discount"
            v-model="fields.is_cashdiscount"
            color="primary"
            box
            hide-details
            disabled
          ></v-checkbox>
        </v-flex>

        <v-flex xs12 sm4>
          <v-text-field
            label="Email"
            v-model="fields.email"
            :rules="emailRules"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            label="Password"
            v-model="fields.password"
            box
            hide-details
            required
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm4>
          <v-text-field
            label="Cash Discount Schedule"
            v-model="fields.cashdiscount_schedule"
            box
            hide-details
            disabled
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap align-center>
        <h3 class="pa-2 primary--text">Address</h3>
        <v-divider class="primary"></v-divider>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm4>
          <v-text-field
            label="Address"
            v-model="fields.address"
            box
            hide-details
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-select
            label="City"
            v-model="fields.city"
            :items="cities"
            box
            hide-details
          ></v-select>
        </v-flex>
        <v-flex xs12 sm4>
          <StateField
            v-model="fields.state"
            icon="fa-info-circle"
          ></StateField>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            label="Postal Code"
            v-model="fields.zip"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            label="Phone"
            v-model="fields.phone"
            mask="(###) ###-####"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-select
            label="County"
            v-model="fields.county"
            :items="counties"
            box
            hide-details
          ></v-select>
        </v-flex>
        <v-flex xs12 sm8>
          <v-text-field
            label="Hours"
            v-model="fields.hours"
            box
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap align-center>
        <h3 class="pa-2 primary--text">Checking</h3>
        <v-divider class="primary"></v-divider>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm4>
          <v-text-field
            label="ABA"
            v-model="fields.aba"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
          <v-text-field
            label="DDA"
            v-model="fields.dda_decoded"
            box
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap align-center>
        <h3 class="pa-2 primary--text">Transaction Services</h3>
        <v-divider class="primary"></v-divider>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-text-field
            label="Client ID"
            v-model="fields.trxservices_client_id"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field
            label="Source ID"
            v-model="fields.trxservices_source_id"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field
            label="Algorithm"
            v-model="fields.trxservices_algorithm"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field
            label="Algorithm Mode"
            v-model="fields.trxservices_algorithm_mode"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            label="Algorithm Key"
            v-model="fields.trxservices_key"
            box
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            label="Algorithm IV"
            v-model="fields.trxservices_iv"
            box
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap align-center>
        <h3 class="pa-2 primary--text">Notes</h3>
        <v-divider class="primary"></v-divider>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-textarea
            label="Notes"
            v-model="fields.notes"
            box
            hide-details
            height
            rows="1"
          ></v-textarea>
        </v-flex>
      </v-layout>

      <v-divider class="primary"></v-divider>

      <v-layout row wrap>
        <v-flex xs12>
          <v-layout row wrap justify-end>
            <v-btn color="primary" @click="save">save</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

import StateField from '@/components/forms/StateDropdown'

export default {
  components: {
    StateField
  },

  mixins: [
    APIMixin,
    AuthMixin,
    DisplayMixin,
    StoreMixin
  ],

  data: function () {
    return {
      cities: [
        'Ada',
        'Altus',
        'Anadarko',
        'Ardmore',
        'Bartlesville',
        'Bethany',
        'Bixby',
        'Blackwell',
        'Blanchard',
        'Broken Arrow',
        'Catoosa',
        'Chickasha',
        'Choctaw',
        'Claremore',
        'Clinton',
        'Collinsville',
        'Coweta',
        'Cushing',
        'Del City',
        'Duncan',
        'Durant',
        'Edmond',
        'El Reno',
        'Elk City',
        'Enid',
        'Glenpool',
        'Grove',
        'Guthrie',
        'Guymon',
        'Harrah',
        'Henryetta',
        'Holdenville',
        'Hugo',
        'Idabel',
        'Jenks',
        'Lawton',
        'Lone Grove',
        'McAlester',
        'Miami',
        'Midwest City',
        'Moore',
        'Muskogee',
        'Mustang',
        'Newcastle',
        'Noble',
        'Norman',
        'Oklahoma City',
        'Okmulgee',
        'Owasso',
        'Pauls Valley',
        'Perry',
        'Piedmont',
        'Ponca City',
        'Poteau',
        'Pryor Creek',
        'Purcell',
        'Sallisaw',
        'Sand Springs',
        'Sapulpa',
        'Seminole',
        'Shawnee',
        'Skiatook',
        'Stillwater',
        'Tahlequah',
        'Tecumseh',
        'The Village',
        'Tulsa',
        'Tuttle',
        'Vinita',
        'Wagoner',
        'Warr Acres',
        'Watonga',
        'Weatherford',
        'Woodward',
        'Yukon'
      ],
      counties: [
        'Adair',
        'Alfalfa',
        'Atoka',
        'Beaver',
        'Beckham',
        'Blaine',
        'Bryan',
        'Caddo',
        'Canadian',
        'Carter',
        'Cherokee',
        'Choctaw',
        'Cimarron',
        'Cleveland',
        'Coal',
        'Comanche',
        'Cotton',
        'Craig',
        'Creek',
        'Custer',
        'Delaware',
        'Dewey',
        'Ellis',
        'Garfield',
        'Garvin',
        'Grady',
        'Grant',
        'Greer',
        'Harmon',
        'Harper',
        'Haskell',
        'Hughes',
        'Jackson',
        'Jefferson',
        'Johnston',
        'Kay',
        'Kingfisher',
        'Kiowa',
        'Latimer',
        'Le Flore',
        'Lincoln',
        'Logan',
        'Love',
        'Major',
        'Marshall',
        'Mayes',
        'McClain',
        'McCurtain',
        'McIntosh',
        'Murray',
        'Muskogee',
        'Noble',
        'Nowata',
        'Okfuskee',
        'Oklahoma',
        'Okmulgee',
        'Osage',
        'Ottawa',
        'Pawnee',
        'Payne',
        'Pittsburg',
        'Pontotoc',
        'Pottawatomie',
        'Pushmataha',
        'Roger Mills',
        'Rogers',
        'Seminole',
        'Sequoyah',
        'Stephens',
        'Texas',
        'Tillman',
        'Tulsa',
        'Wagoner',
        'Washington',
        'Washita',
        'Woods',
        'Woodward'
      ],

      nameRules: [
        (v) => !!v || 'Name is required'
      ],
      emailRules: [
        (v) => !v || /.+@.+/.test(v) || 'Email must be valid'
      ],
      passwordRules: [
        (v) => !!v || 'Password is required'
      ],
      addressRules: [
        (v) => !!v || 'Address is required'
      ],
      cityRules: [
        (v) => !!v || 'City is required'
      ],
      stateRules: [
        (v) => !!v || 'State is required'
      ],
      postalcodeRules: [
        (v) => !!v || 'Postal code is required'
      ],

      agency: {},
      fields: this.defaultFormFields()
    }
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    }
  },

  mounted () {
    if (this.$route.params.hasOwnProperty('id') && this.$route.params.id) {
      this.load()
    }
  },

  watch: {
    $route (to, from) {
      this.reset()
    }
  },

  methods: {
    reset () {
      this.fields = this.defaultFormFields()
      if (this.$route.params.hasOwnProperty('id') && this.$route.params.id) {
        this.load()
      }
    },

    defaultFormFields () {
      return {
        name: '',
        tracking_id: '',
        email: '',
        password: '',
        is_cashdiscount: true,
        cashdiscount_schedule: 'okdmv',
        address: '',
        city: '',
        state: 'OK',
        zip: '',
        phone: '',
        county: '',
        hours: '',
        aba: '',
        dda_decoded: '',
        trxservices_client_id: '',
        trxservices_source_id: '1',
        trxservices_algorithm: 'Rijndael',
        trxservices_algorithm_mode: 'CBC',
        trxservices_key: '',
        trxservices_iv: '',
        notes: ''
      }
    },

    async load () {
      try {
        Bus.$emit('openWaitModal')

        if (!this.$route.params.id) {
          throw new Error('Invalid agency')
        }

        let data = await this.api({url: `/okdmv_agencies/${this.$route.params.id}`})

        // match to form fields
        // @TODO Before/after logic to show what has changed on UI and only submit those changes to the API
        this.agency = data.data.agency
        for (const [key, value] of Object.entries(data.data.agency)) {
          if (this.fields.hasOwnProperty(key)) {
            this.fields[key] = value
          }
        }
      } catch (error) {
        Bus.$emit('openModal', {status: 'error', message: error})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },

    async save () {
      try {
        if (!this.$refs.form1.validate()) {
          let errors = []
          this.$refs.form1.inputs.forEach(e => {
            if (e.hasError) {
              errors.push(e.errorBucket[0])
            }
          })

          let message = 'Validation Error'

          if (errors.length > 1) {
            message = 'Validation Errors'
          }

          Bus.$emit('openModal', {
            status: 'error',
            message: message,
            messageDetails: errors
          })

          return false
        }

        Bus.$emit('openWaitModal')

        let options = { ...this.fields }

        let result = await this.api({
          method: this.$route.params.id ? 'put' : 'post',
          url: `/okdmv_agencies`,
          data: options
        })

        if (result.data.response.ResponseText === 'APPROVED') {
          this.transactionDetails = result.data.response.Transaction
          this.responseMessage = 'Payment Accepted'
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }
          this.transactionDetails = {}
          this.recurringTransactionDetails = {}
          this.isResponseError = true
          this.responseMessage = error
          this.responseMessageDetails = ''
          this.isProcessing = false

          if (error === 'DECLINED' && this.$route.name === 'ChargeCard') {
            this.responseMessageDetails = 'Please verify card data including the expiration and CVV'
          }

          if (result.data.response.Transaction && result.data.response.Transaction.hasOwnProperty('error_messages') && result.data.response.Transaction.error_messages) {
            let messages = JSON.parse(result.data.response.Transaction.error_messages)

            // show detailed error as long as it isn't the generic 'do not honor'
            if (messages.length > 0 && messages[0] !== 'TRANS DENIED DO NOT HONOR' && messages[0] !== error) {
              this.responseMessageDetails = messages.join()
            }
          }
        }

        this.resultModal = true
        this.responses.unshift(result.data)
        this.panel = [true]
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        this.isProcessing = false
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/okdmv/AgencyEdit.vue